module.exports = __webpack_public_path__ + "img/5.478cf574.jpg";